import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const labGroupsLabEditRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/groups_labs/$id/edit',
  params: z.object({ id: zodPathParamId }),
}).lazy(() =>
  import('pages/lab/GroupsLabs/LabGroupsLabEditPage/LabGroupsLabEditPage').then((d) => d.Route)
);
